import * as React from 'react';
import cn from '~modules/cn';

import './list-item-buttons.scss';

type Props = {
    children?: React.ReactNode;
    className?: string;
};

const ListItemButtons = React.forwardRef<HTMLDivElement, Props>((props, ref) => (
    <div className={cn('list-item-buttons', props.className)} ref={ref}>
        {props.children}
    </div>
));

ListItemButtons.displayName = 'ListItemButtons';

export default ListItemButtons;
